export enum ETravelByOptions {
  BOAT = 'boat',
  BUS = 'bus',
  CAR = 'car',
  PLANE = 'plane',
  TRAIN = 'train'
}
